export default __webpack_public_path__ + "static/media/chat-bubbles-with-ellipsis.42a8cc90.svg";